export default {
  methods: {
    async out() {
      await this.outTl.restart()
    },
  },
}
